import React, { useContext, useState } from 'react'
import Header from "../../components/headerAdmin/Header.js"
import './jdcandidatelist.css'
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import "react-datepicker/dist/react-datepicker.css";
import { UserTypeContext } from '../../AppRoute.js';
import JdCandidateSearch from '../../components/jobdesccandidatesearch/jdcandidatessearch.js';
import JdCandidateTable from '../../components/jobdesccandidatesearch/jdcandidatestable.js';



const JdCandidateList = () => {
    const location = useLocation();
    const { userType, userRecords } = useContext(UserTypeContext);
    const history = useNavigate();
    const userIdType = location?.state?.id ? location?.state?.id : userRecords?.id;
    const userRole = location?.state?.userRole ? location?.state?.userRole : userRecords?.role?.roleName;
    const userRecruitmentpartnerId = location?.state?.userRecruitmentpartnerId ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId;

    const [triggerExport, setTriggerExport] = useState(false);
    const [isfilterSearch, setIsfilterSearch] = useState(false);

    const [filterValues, setFilterValues] = useState({
        candidateName: "",
        candidateEmail: "",
    });



    const gotoDashBoard = () => {
        history(location?.state?.toggleAiScreen ? "/interview-management" : "/interview-management-vet", {
            state: { id: userIdType, recruitementPartnerId: userRecruitmentpartnerId, userType: userType, userRecords: userRecords, userRole: userRole },
        });
    }

    return (
        <div className='mainContainer_jdCandidateList'>
            <div className='topContainer_jdCandidateList'>
                <div className='mainDiv_jdCandidateList'>
                    <div className='gobackContainer_jdCandidateList'>
                        <div className="reportHeader_jdCandidateList">
                            <Tooltip title={userType === "MIS Operator" ? "Go Back to Requisition Dashboard" : "Go Back to Dashboard"} placement="bottom">
                                <div className="goBackButton_jdCandidateList" onClick={(e) => gotoDashBoard()}>
                                    <ArrowBack sx={{ fontSize: 20 }} />
                                </div>
                            </Tooltip>
                            <div className="reportTitle_jdCandidateList">Candidate List</div>
                        </div>
                    </div>

                    <div className="mainContentContainer_jdCandidateList">
                        <div className='sideContainer_jdCandidateList'>
                            <JdCandidateSearch
                                setFilterValues={setFilterValues}
                                setIsfilterSearch={setIsfilterSearch}
                                isVetScreenOpen={location?.state?.toggleAiScreen}
                            />
                        </div>
                        <div className="wrapperContainer_jdCandidateList">
                            <div className='gridContainer_jdCandidateList'>

                                <JdCandidateTable
                                    isfilterSearch={isfilterSearch}
                                    setIsfilterSearch={setIsfilterSearch}
                                    filterValues={filterValues}
                                    userType={userType === 'Admin' ? userRole : userType}
                                    userIdType={userIdType}
                                    userRecruitmentpartnerId={userRecruitmentpartnerId}
                                    userRecords={userRecords}
                                    triggerAction={triggerExport}
                                    resetTrigger={() => setTriggerExport(false)}
                                    jdId={location?.state?.jdId}
                                    toggleAiScreen={location?.state?.toggleAiScreen}
                                    vetTestId={location?.state?.vetTestId || null}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JdCandidateList